import { defineNuxtPlugin, useUserStore } from '#imports'
import { watch } from 'vue'

import { useUpdateTrackingUserContext } from '../composables/useUpdateTrackingUserContext/useUpdateTrackingUserContext'

export default defineNuxtPlugin(() => {
  const { updateTrackingUserContext } = useUpdateTrackingUserContext()
  const { isUserFetched } = useUserStore()

  // If the user was fetched server-side, update the user context immediately
  // If the user is fetched client-side, wait for it to be fetched to update the user context
  watch(
    isUserFetched,
    () => {
      if (isUserFetched.value) {
        void updateTrackingUserContext()
      }
    },
    { immediate: true },
  )
})
